import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LinkBar from "../../LinkBar/LinkBar";
import Search from "../Search/Search";

const Subjects = () => {
  const { series, dept, semester, subject } = useParams();
  const [resources, setResources] = useState([]);

  useEffect(() => {
    series &&
      dept &&
      semester &&
      subject &&
      fetch(
        `https://apichothaon1-hzrifat.b4a.run/resources/${series}/${dept}/${semester}/${subject}/false`
      )
        .then((res) => res.json())
        .then((data) => setResources(data));
  }, [series, dept, semester, subject]);

  // console.log(resources);

  return (
    <div>
      <div className="container row">
        <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
          <Search />
        </div>
        <div className="col-md-8 col-sm-6 col-12">
          <LinkBar
            series={series}
            dept={dept}
            semester={semester}
            subject={subject}
          />
          <div className="row my-5 ">
            {resources?.length
              ? resources?.map((r) => {
                  return (
                    <div className="col-4 col-md-6 col-12">
                      <div
                        style={{ background: "rgba(255, 255, 255, 0.5)" }}
                        className="rounded shadow-lg my-2 mx-0 p-4"
                      >
                        <h4>
                          {r?.subjectName ? (
                            r?.subjectName
                          ) : (
                            <span>Subject Not Specified</span>
                          )}
                        </h4>
                        <p>
                          {r?.subject} - {r?.series} Series
                        </p>
                        {r?.uploader ? (
                          <p className="text-secondary">
                            <small>Shared by {r?.uploader}</small>
                          </p>
                        ) : (
                          <p className="text-secondary">
                            <small>Unknown Sharer</small>
                          </p>
                        )}
                        <p>
                          <span style={{ fontWeight: "500" }}>Title:</span>{" "}
                          {r?.title}
                        </p>
                        {r?.details ? (
                          <p>
                            <span style={{ fontWeight: "500" }}>Details:</span>{" "}
                            {r?.details}
                          </p>
                        ) : null}
                        <a target="_blank" href={r?.link}>
                          <button className="btn-custom border-0 rounded px-2 py-1">
                            Study
                          </button>
                        </a>
                        <span className="ms-2 text-success">Verified</span>
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subjects;
